<template>
	<div>
		<!-- breadcrumb area -->
		<div class="breadcrumb-area breadcrumb-padding bg-img" :style="{backgroundImage:`url(${bgImg})`}">
			<div class="container">
				<div class="breadcrumb-content text-center">
					<h2>个人主页</h2>
				</div>
			</div>
		</div>
		<!-- Project area -->
		<div class="section section-padding">
			<div class="container">
				<div class="row">
					<div class="col-lg-3">
						<div class="sidebar-wrap sidebar-margin-right">
							<div class="sidebar-widget">
								<div class="sidebar-categori">
									<el-menu default-active="1" unique-opened active-text-color='#009C44'
										class="el-menu-vertical-demo" @select="handleSelect">
										<el-menu-item index="1">
											<span slot="title">基本信息</span>
										</el-menu-item>
										<el-menu-item index="2">
											<span slot="title">我的发布</span>
										</el-menu-item>
										<el-menu-item index="3">
											<span slot="title">浏览记录</span>
										</el-menu-item>
										<el-menu-item index="4">
											<span slot="title">我的收藏</span>
										</el-menu-item>
										<el-menu-item index="5">
											<span slot="title">我的评论</span>
										</el-menu-item>
									</el-menu>
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-9">
						<div v-if="currentTab == 1">
							<h5 style="color: #4A4A4A;">基本信息</h5>
							<div class="user-info">
								<div style="display: flex;flex-direction: column;align-items: center;">
									<el-avatar :size="100" :src="userInfo.avatar"></el-avatar>
									<el-tag v-if="userInfo.verify_flag == 0" class="mt-1" effect="dark">未认证</el-tag>
									<el-tag v-else class="mt-1" effect="dark">已认证</el-tag>
								</div>

								<div class="user-des">
									<p style="color: #4A4A4A;font-size: 18px;" class="mb-1">
										{{userInfo.nickname}}（{{userInfo.zk_id}}）</p>
									<p v-if="userInfo.is_vip && userInfo.is_vip == 1">
										<el-tag effect="dark" type="warning" size="small">VIP</el-tag>
										{{userInfo.vip_start}}至{{userInfo.vip_end}}
									</p>
									<p>{{userInfo.signature}}</p>

									<p>绑定手机：{{userInfo.account}}</p>

									<p>点赞：{{userInfo.like_count}}</p>
									<p>关注：{{userInfo.focus_count}}</p>
									<p>粉丝：{{userInfo.fans_count}}</p>
								</div>
							</div>
							<h5 style="color: #4A4A4A;">联系我们</h5>
							<div class="user-info">
								<div style="width: 100px;"></div>
								<div class="user-des">
									<p>服务热线：0755-83065200</p>
									<p>我们的微信：筑壳</p>
									<p>总部地址：深圳市龙岗区坂田街道坂田国际中心A座1508号</p>
								</div>
							</div>
						</div>
						<div v-if="currentTab == 2">
							<div class="project-menu-style project-menu-active isotope-btn-add-active mb-6">
								<button v-for="(item,index) in cateList" :key="index"
									:class="cateIndex==item.id?'active':''" class="btn-project" data-filter="*"
									@click="clickCate(item.id)">{{item.cate_name}}</button>
							</div>
							<div v-if="listData.length>0">
								<div class="row row-cols-xl-4 row-cols-lg-3 row-cols-md-2 row-cols-sm-2 row-cols-1 mb-n6 grid"
									style="position: relative;min-height: 350px;">
									<div class="col mb-6" v-for="(item,index) in listData" :key="item.id">
										<div class="blog-wrap">
											<div class="blog-img mb-2">
												<div style="cursor: pointer;" @click="entryDetial(item)">
													<img :src="item.image | imgfilter" alt="Blog Image">
												</div>
											</div>
											<div class="blog-content d-flex">
												<div style="flex: 1;">
													<div style="cursor: pointer;" @click="entryDetial(item)">
														<div>{{item.name}}</div>
													</div>
													<span class="tag" v-for="(ta,ti) in item.tags">{{ta}}</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div v-else>
								<el-empty :image-size="200"></el-empty>
							</div>
						</div>
						<div v-if="currentTab == 3">
							<div class="project-menu-style project-menu-active isotope-btn-add-active mb-6">
								<button v-for="(item,index) in cateList" :key="index"
									:class="cateIndex==item.id?'active':''" class="btn-project" data-filter="*"
									@click="clickCate(item.id)">{{item.cate_name}}</button>
							</div>
							<div v-if="listData.length>0">
								<div
									class="row row-cols-xl-4 row-cols-lg-3 row-cols-md-2 row-cols-sm-2 row-cols-1 mb-n6 grid">
									<div class="col mb-6" v-for="(item,index) in listData" :key="item.id">
										<div class="blog-wrap">
											<div class="blog-img mb-2">
												<div style="cursor: pointer;" @click="entryDetial(item)">
													<img :src="item.image | imgfilter" alt="Blog Image">
												</div>
											</div>
											<div class="blog-content d-flex">
												<div style="flex: 1;">
													<div style="cursor: pointer;" @click="entryDetial(item)">
														<div>{{item.name}}</div>
													</div>
													<span class="tag" v-for="(ta,ti) in item.tags">{{ta}}</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div v-else>
								<el-empty :image-size="200"></el-empty>
							</div>
						</div>
						<div v-if="currentTab == 4">
							<div class="project-menu-style project-menu-active isotope-btn-add-active mb-6">
								<button v-for="(item,index) in cateList" :key="index"
									:class="cateIndex==item.id?'active':''" class="btn-project" data-filter="*"
									@click="clickCate(item.id)">{{item.cate_name}}</button>
							</div>
							<div v-if="listData.length>0">
								<div
									class="row row-cols-xl-4 row-cols-lg-3 row-cols-md-2 row-cols-sm-2 row-cols-1 mb-n6 grid">
									<div class="col mb-6" v-for="(item,index) in listData" :key="item.id">
										<div class="blog-wrap">
											<div class="blog-img mb-2">
												<div style="cursor: pointer;" @click="entryDetial(item)">
													<img :src="item.image | imgfilter" alt="Blog Image">
												</div>
											</div>
											<div class="blog-content d-flex">
												<div style="flex: 1;">
													<div style="cursor: pointer;" @click="entryDetial(item)">

														<div>{{item.name}}</div>

													</div>
													<span class="tag" v-for="(ta,ti) in item.tags">{{ta}}</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div v-else>
								<el-empty :image-size="200"></el-empty>
							</div>
						</div>
						<div v-if="currentTab == 5">
							<div class="project-menu-style project-menu-active isotope-btn-add-active mb-6">
								<button v-for="(item,index) in cateList" :key="index"
									:class="cateIndex==item.id?'active':''" class="btn-project" data-filter="*"
									@click="clickCate(item.id)">{{item.cate_name}}</button>
							</div>
							<div v-if="listData.length>0">
								<div class="row row-cols-lg-2 row-cols-md-2 row-cols-sm-2 row-cols-1">
									<div class="col mb-6" v-for="(item,index) in listData" :key="item.id">
										<div class="comment">
											<img v-if="cateIndex == 1" :src="item.projectInfo.image" alt="">
											<img v-if="cateIndex == 2" :src="item.productInfo.image" alt="">
											<img v-if="cateIndex == 3" :src="item.showtInfo.image" alt="">
											<div class="commtext">
												<div v-if="cateIndex == 1">案例标题：{{ item.projectInfo.name }}</div>
												<div v-if="cateIndex == 2">产品标题：{{ item.productInfo.name }}</div>
												<div v-if="cateIndex == 3">展厅标题：{{ item.showtInfo.name }}</div>
												<div>评论内容：{{ item.comment }}</div>
												<div style="margin-top: 10px;">评论时间：{{ item.add_time }}</div>
												<div class="commdel">
													<span class="tag-btn" @click="entryComment(item)">查看</span>
												</div>
											</div>
										</div>
										
									</div>
								</div>
							</div>
							<div v-else>
								<el-empty :image-size="200"></el-empty>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getCookies,
		removeCookies,
	} from '@/libs/util'
	import {
		getShowList,
		ShowLikeAdd,
		ShowLikeDel,
		getUserInfo,

		projectList,
		productList,
		showList,

		userVisit,

		collectUser,

		myProjectCommentList,
		myShowCommentList,
		myProductCommentList,
	} from '@/api'
	export default {
		data() {
			return {
				userInfo: {},

				nameInfo: '',
				bgImg: require('../static/images/banner/banner-3.jpg'),
				cateList: [{
					id: 1,
					cate_name: '案例'
				}, {
					id: 3,
					cate_name: '展厅'
				}, {
					id: 2,
					cate_name: '产品'
				}],
				cateIndex: 1,

				currentTab: 1,

				listData: [],
				total: 0,
				currentPage: 1,
				pid: 0,

				spinShow: false,
				
				noDate: true
			}
		},
		created() {
			this.getUserInfo()
		},

		mounted() {
			let _this = this;
			window.onscroll = function() {
				//变量scrollTop是滚动条滚动时，距离顶部的距离
				var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				//变量windowHeight是可视区的高度
				var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
				//变量scrollHeight是滚动条的总高度
				var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
				//滚动条到底部的条件
				if (scrollTop + windowHeight == scrollHeight) {
					_this.currentPage = parseInt(_this.currentPage+1)
					_this.getListData();
				}
			}
		},
		computed: {
			isLogin() {
				return getCookies("webtoken");
			},
		},
		methods: {
			
			entryComment(item) {
				switch (this.cateIndex) {
					case 1:
						this.$router.push({
							path: '/projectDetail/' + item.project_id
						})
						break;
					case 2:
						this.$router.push({
							path: '/productDetail/' + item.product_id
						})
						break;
					case 3:
						this.$router.push({
							path: '/showDetail/' + item.show_id
						})
						break;
					default:
						break;
				}
			},

			// 详情跳转
			entryDetial(item) {
				switch (this.cateIndex) {
					case 1:
						this.$router.push({
							path: '/projectDetail/' + item.id
						})
						break;
					case 2:
						this.$router.push({
							path: '/productDetail/' + item.id
						})
						break;
					case 3:
						this.$router.push({
							path: '/showDetail/' + item.id
						})
						break;
					default:
						break;
				}
			},

			async getUserInfo() {
				const res = await getUserInfo()
				this.userInfo = res.data
			},

			// 页数跳转
			handleCurrentChange(val) {
				this.currentPage = val
				this.getShowList()
				document.documentElement.scrollTop = 0
			},

			// 专栏分类选择
			handleSelect(key, keyPath) {
				this.cateIndex = 1
				this.currentTab = key
				this.pid = key || 0
				this.currentPage = 1
				document.documentElement.scrollTop = 0
				this.listData = []
				this.getListData()
			},

			// 点击分类
			clickCate(item) {
				this.cateIndex = item
				this.currentPage = 1
				this.listData =[]
				this.getListData()
			},
			
			getListData() {
				switch (this.currentTab) {
					case '1':
						this.getUserInfo()
						break;
					case '2':
						this.getMyResele()
						break;
					case '3':
						this.getMyVisit()
						break;
					case '4':
						this.getMyCollent()
						break;
					case '5':
						this.getMyComment()
						break;
					default:
						break;
				}
			},

			// 获取我的发布
			getMyResele() {
				switch (this.cateIndex) {
					case 1:
						projectList({
							page: this.currentPage,
							limit: 50,
						}).then(res => {
							this.spinShow = false
							let data = res.data || []
							data.forEach(e => {
								if(e.tags) e.tags = e.tags.split(',') || []
							})
							this.listData = this.listData.concat(data)
						}).catch(err => {
							this.spinShow = false
						})
						break;
					case 2:
						productList({
							page: this.currentPage,
							limit: 50,
						}).then(res => {
							this.spinShow = false
							let data = res.data || []
							data.forEach(e => {
								if(e.tags) e.tags = e.tags.split(',') || []
							})
							this.listData = this.listData.concat(data)
						}).catch(err => {
							this.spinShow = false
						})
						break;
					case 3:
						showList({
							page: this.currentPage,
							limit: 50,
						}).then(res => {
							this.spinShow = false
							let data = res.data || []
							data.forEach(e => {
								if(e.tags) e.tags = e.tags.split(',') || []
							})
							this.listData = this.listData.concat(data)
						}).catch(err => {
							this.spinShow = false
						})
						break;
					default:
						break;
				}
			},

			// 获取我的浏览记录
			getMyVisit() {
				userVisit({
					type: this.cateIndex,
					page: this.currentPage,
					limit: 50,
				}).then(res => {
					let data = res.data.map(e => {
						switch (this.cateIndex) {
							case 1:
								if (e.projectInfo) return e.projectInfo
								break;
							case 2:
								if (e.productInfo) return e.productInfo
								break;
							case 3:
								if (e.showInfo) return e.showInfo
								break;
							default:
								if (e.productInfo) return e.productInfo
								break;
						}
					})
					let target = data.filter(current => {
						return current !== null && current !== undefined
					})
					this.listData = this.listData.concat(target)
				})
			},

			// 获取我的收藏
			getMyCollent() {
				collectUser({
					type: this.cateIndex - 1,
					page: this.currentPage,
					limit: 50,
				}).then(res => {
					let data = res.data.map(e => {
						switch (this.cateIndex) {
							case 1:
								return e.projectInfo
								break;
							case 2:
								return e.productInfo
								break;
							case 3:
								return e.showInfo
								break;
							default:
								return e.productInfo
								break;
						}
					})
					data.forEach(e => {
						if(e.tags) e.tags = e.tags.split(',') || []
					})
					this.listData = this.listData.concat(data)
				})
			},

			// 获取我的评论
			getMyComment() {
				switch (this.cateIndex) {
					case 1:
						myProjectCommentList({
							page: this.currentPage,
							limit: 50,
						}).then(res => {
							let data = res.data.list || []
							data.forEach(e => {
								if(e.tags) e.tags = e.tags.split(',') || []
							})
							this.listData = this.listData.concat(data)
						}).catch(() => {

						})
						break;
					case 2:
						myProductCommentList({
							page: this.currentPage,
							limit: 50,
						}).then(res => {
							let data = res.data.list || []
							data.forEach(e => {
								if(e.tags) e.tags = e.tags.split(',') || []
							})
							this.listData = this.listData.concat(data)
						}).catch(() => {

						})
						break;
					case 3:
						myShowCommentList({
							page: this.currentPage,
							limit: 50,
						}).then(res => {
							let data = res.data.list || []
							data.forEach(e => {
								if(e.tags) e.tags = e.tags.split(',') || []
							})
							this.listData = this.listData.concat(data)
						}).catch(() => {

						})
						break;
				}
			},


			collect(item) {
				if (!this.isLogin) {
					alert('请登录后操作')
					return false
				}
				if (item.isLike == 0) {
					ShowLikeAdd({
						show_id: item.id
					}).then((res) => {
						if (res.status == 200) {
							item.isLike = 1
							item.like_count++
						}
					})
				} else {
					ShowLikeDel({
						show_id: item.id
					}).then((res) => {
						if (res.status == 200) {
							item.isLike = 0
							item.like_count--
						}
					})
				}
			},
		}
	}
</script>

<style scoped>
	.user-info {
		display: flex;
		margin-top: 30px;
	}

	.user-des {
		flex: 1;
		margin-left: 50px;
	}

	.user-des p {
		margin-bottom: 20px;
	}

	.comment {
		display: flex;
		align-items: center;
		padding: 15px 20px;
		border: 1px solid #ccc;
		border-radius: 5px;
	}
	
	.comment img {
		width: 100px;
		height: 100px;
	}
	
	.comment .commtext {
		flex: 1;
		margin-left: 10px;
	}
	
	.commdel {
		float: right;
		margin-top: 10px;
	}
</style>
